package one.devsbox.www.ui.devices.edit

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.TextFieldValue
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import one.devsbox.shared.ads.SharedIO
import one.devsbox.shared.ads.SharedIO.LocationSimple
import one.devsbox.shared.devices.ScreenRotation
import one.devsbox.shared.files.AspectRatio
import one.devsbox.www.provider.LocalMeProvider
import one.devsbox.www.provider.LocalNavigationCallbackProvider
import one.devsbox.www.provider.MeProvider
import one.devsbox.www.provider.NavigationCallbackProvider
import one.devsbox.www.tools.*
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.LocalNavigationArgs
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.args
import tk.mallumo.compose.navigation.viewmodel.viewModel

class DeviceECtx private constructor(
    val vm: DeviceEVM,
    val nav: Navigation,
    val args: ArgsId,
    val navCallback: NavigationCallbackProvider,
    val me: MeProvider,
    val colorPrimaryContainer: Color,
    val colorSecondaryContainer: Color,
    val colorErrorContainer: Color
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): DeviceECtx {
            val nav = LocalNavigation.current
            val navCallback = LocalNavigationCallbackProvider.current
            val args = LocalNavigationArgs.current.args<ArgsId>()
            val vm = nav.viewModel(DeviceEVM::class)
            val me = LocalMeProvider.current
            val colorPrimary = MaterialTheme.colorScheme.primaryContainer
            val colorSecondary = MaterialTheme.colorScheme.secondaryContainer
            val colorError = MaterialTheme.colorScheme.errorContainer
            return remember(args.id) {
                DeviceECtx(
                    vm, nav, args, navCallback, me,
                    colorPrimary, colorSecondary, colorError
                ).apply {
                    vm.setup(this)
                }
            }
        }
    }

    class Editor(
        val scope: CoroutineScope,
        val device: SharedIO.Device,
        val locations: List<LocationSimple>
    ) {

        val data: SharedIO.DeviceChange = SharedIO.DeviceChange(
            locationId = device.info.locationId,
            photoId = device.info.photoId,
            name = device.info.name,
            address = device.info.address,
            screenW = device.content.config.screenW,
            screenH = device.content.config.screenH,
            screenR = device.content.config.screenR,
            aspectRatio = device.info.aspectRatio,
            deviceType = device.info.type
        )

        fun changeLocation(location: LocationSimple) {
            nameLocation.set(location.name)
            data.locationId = location.id
        }

        val photo = EFieldRegularLong(data::photoId)
        val deviceType = EFieldRegularInt(data::deviceType)
        private val locationId = EFieldRegularLong(data::locationId)

        val name = EFieldTextValue(
            property = data::name,
            condition = { it.trim().takeIf { it.isNotEmpty() } }
        )
        val address = EFieldTextValue(
            property = data::address,
            condition = { it.trim() }
        )
        val nameLocation = EFieldRegularString(
            property = device.info::nameLocation,
        )

        val aspectRatio = EFieldRegularString(
            property = data::aspectRatio
        )

        val width = EFieldTextInt(
            property = data::screenW,
            condition = { it.toIntOrNull()?.takeIf { it in 1..7680 } },
            onChange = { makeAspectRatio() })

        val height = EFieldTextInt(
            property = data::screenH,
            condition = { it.toIntOrNull().takeIf { it in 1..7680 } },
            onChange = { makeAspectRatio() })

        val rotation = EFieldRegularInt(
            property = data::screenR,
            onChange = {

                val rot = ScreenRotation[it]!!
                fun swapRotation() {
                    val w = TextFieldValue(width.state.toString())
                    width.set(TextFieldValue(height.state.toString()))
                    height.set(w)
                }
                if (rot match ScreenRotation.HORIZONTAL + ScreenRotation.HORIZONTAL_REVERSED) {
                    if (width.state < height.state) swapRotation()
                } else {
                    if (width.state > height.state) swapRotation()
                }

            })


        fun makeAspectRatio() {
            scope.launch {
                aspectRatio.set(AspectRatio.closestStandard(data.screenW, data.screenH).label())
            }
        }


//        private val required get() = listOf(name, width, height, rotation, aspectRatio)
//
//        private val optional get() = listOf(photo)

    }
}

